import { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../contexts/auth';
import { useNavigate } from 'react-router-dom';

//import './login.css';
import logo from '../../assets/images/logo.webp'
import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais';

export default function Login() {
  const [user, setUser] = useState('');
  const [senha, setSenha] = useState('');

  const { signIn, usuario, loadingAuth, signed } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    navegar();
      return() => {}
  }, [signed]);

  async function handleSubmit(e){
    e.preventDefault();

    if(user !== '' && senha !== ''){
      console.log("User: ", user);
      console.log("Senha: ", senha);

      signIn(user, senha);
      navegar()
    }
  }
  
  function navegar() {
      if (signed) {
        toast.success("Bem vindo ao Sistema " + usuario.nome);
        navigate("/principal");

        // if (usuario.perfil === 'GS') {
        //   navigate("/dashboard");
        
        // } else {
        //   navigate("/principal");
        // }
      }
    }

  return(
    <main className='container h-full mx-auto px-4 md:px-4 mt-10'>
      <section className='flex h-full items-center justify-center'>
        <article className='bg-white p-5 rounded-md'>
          <a href="http://www.analub.com.br">
            <img src={logo} className='max-w-full mx-auto' alt="Analub - Purificação de Lubrificantes"/></a>
          <div className="project-name text-center border-b border-secondary">
            <h1 className='text-lg font-semibold'>Gerenciamento da Qualidade Funcional do Fluido - GQFF</h1>
            {Globais.versao_teste === 'Sim' ?  ( <h4>Versão de Teste</h4> ) : (<></>)} 
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-group mb-3">
              <label htmlFor="username">Usuário</label>
              <div className="single-input"> 
                <div className='w-full p-2 border border-gray-300 rounded-md'> 
                  <input type="text" id='username' name='username' placeholder='Usuário' value={user} onChange={(e) => setUser(e.target.value)} />
                </div>
              </div>
            </div> 

            <div className="input-group">
              <label htmlFor="password">Senha</label>
              <div className="single-input relative">
                <div  className='w-full p-2 border border-gray-300 rounded-md pr-10'>
                  <input type="password" id='password' name='password' placeholder='Senha' value={senha} onChange={(e) => setSenha(e.target.value)} />
                </div>
                <button type='button' className="toggle-password icon-input absolute top-1/2 -translate-y-1/2 right-2">
                  <i className="fa-regular fa-eye text-xl"></i>
                </button>
              </div>
            </div>

            <footer className='flex justify-between items-center'>
              {loadingAuth === false ? 
                (
                  <button type='submit' className='border border-secondary text-secondary hover:bg-secondary hover:text-white px-10 py-2 rounded-md'>Entrar</button>
                ) : (
                  <></>            
                )
              }
            </footer>
          </form>
        </article>
      </section>
    </main>
  )
}
